import TicketStatus from "../../interfaces/ticket/TicketStatus";

export async function getStatuses(authToken: string): Promise<TicketStatus[] | null> {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/tickets/statuses`, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            },
        });

        if (!response.ok) {
            console.error("Failed to fetch statuses:", response.status, response.statusText);
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching statuses:", error);
        return null;
    }
}

export async function updateTicketStatus(authToken: string, ticketId: string, statusId: string): Promise<boolean> {
    try {

        console.log('Status ID', statusId);
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/tickets/${ticketId}/status`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify({ statusId: statusId }),
        });

        if (!response.ok) {
            console.error("Failed to update ticket status:", response.status, response.statusText);
            return false;
        }

        return true;
    } catch (error) {
        console.error("Error updating ticket status:", error);
        return false;
    }
}
